import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import type { Dispatch} from 'umi';
import { connect, useIntl } from 'umi';
import { Badge } from 'antd';


import type { InquiryState } from '@/models/inquiry';
import InquiryAvatar from '../InquiryAvatar';
import { OnlineInquiryStatusEnum } from '@/pages/Inquiry/data.d';
import styles from './index.less';

interface InquiryListProps {
  inquiry: InquiryState;
  dispatch: Dispatch;
};


const InquiryList: React.FC<InquiryListProps> = ({
  inquiry,
  dispatch
}) => {
  // 国际化
  const intl = useIntl();
  const c = window.$tc('', intl.formatMessage);
  const t = window.$tc('component.Inquiry.InquiryList', intl.formatMessage);

  const scrollRef = useRef<HTMLDivElement>(null);



  const messageRender = (content?: string) => {
    const parsedContent = JSON.parse(content || '{}');
    const { type, value } = parsedContent;
    switch (type) {
      case 'text':
        return value
      case 'image':
        return '[' + t('t0', '图片') + ']'
      case 'audio':
        return '[' + t('t1', '语音') + ']'
      default:
        // return t('t2', '未知的消息类型')
        return ''
    }
  };

  return (
    <div className={styles.inquiryListWrap}>
      <div className={styles.inquiryListTitle}>{t('t3', '对话列表')}</div>
      <div ref={scrollRef} className={styles.inquiryList}>
        <div>
          {
            inquiry.inquiryList.map((item , index) => (
              <div
                key={index.toString()}
                className={`${styles.inquiryItem} ${inquiry.currentInquiry?.inquiryId === item.inquiryId ? styles.current : ''}`}
                onClick={() => {
                  dispatch({ type: 'inquiry/onInquirySiderListClick', payload: index })
                }}
              >
                <div className={styles.avatar}>
                  <Badge count={item.imMessageBox?.unread}>
                    <InquiryAvatar text={item.familyInfo?.name}/>
                  </Badge>
                </div>
                <div className={styles.inquiryInfo}>
                  <div className={styles.inquiryInfoTop}>
                    <span className={styles.name}>{item.familyInfo?.name}</span>
                    <span className={styles.time}>
                      {item.imMessageBox?.timestamp ? moment(item.imMessageBox.timestamp).format('MM/DD HH:mm') : null}
                    </span>
                  </div>
                  <div className={styles.inquiryInfoBtm}>
                    <span className={styles.text}>
                      {
                        messageRender(item.imMessageBox?.content)
                      }
                    </span>
                    {
                      item.status === OnlineInquiryStatusEnum.待接诊
                        ? <Badge color="red" text={<span className={styles.status}>{t('t5', '待接诊')}</span>}/>
                        : null
                    }
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
};

const mapToProps = ({ inquiry }: { inquiry: InquiryState }) => {
  return {
    inquiry
  }
}

export default connect(mapToProps)(InquiryList);
